export const SIDEBAR_LAYOUT_KEY = Symbol('sidebarLayout');

export const SIDEBAR_MOBILE_BREAKPOINT = 992;

/** Pinned sidebar widths — single source of truth for layout + visual sync. */
export const SIDEBAR_WIDTHS = {
  rail: 76,
  expanded: 264
};

/**
 * Shared pin motion — keep CSS --sidebar-transition-* in sync
 * (content padding-left must match sidebar width tween).
 *
 * Use the SAME ease for expand + collapse so GSAP width and CSS
 * padding-left stay locked (power2.out vs inOut was desyncing expand).
 */
export const SIDEBAR_MOTION = {
  /** Seconds — used by GSAP width tween (expand + collapse). */
  widthDuration: 0.36,
  widthEase: 'power2.inOut',
  /** CSS twin of widthDuration (padding-left on .app-container). */
  widthDurationMs: '360ms',
  /** Matches GSAP power2.inOut for CSS padding-left. */
  widthEasingCss: 'cubic-bezier(0.45, 0, 0.55, 1)',
  labelFadeAt: 0.2,
  labelFade: 0.18,
  labelFadeEase: 'power1.out',
  fadeOut: 0.16,
  fadeOutEase: 'power1.out'
};
